/**
 * Wandelt einen Namen in einen UPN-/mailNickname-tauglichen Teil um
 * (Kleinschreibung, deutsche Umlaute ausgeschrieben, Diakritika entfernt,
 * nur a-z0-9).
 */
export function transliterate(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

export function deriveUpnPrefix(firstName: string, lastName: string): string {
  const f = transliterate(firstName);
  const l = transliterate(lastName);
  if (!f) return l;
  if (!l) return f;
  return `${f}.${l}`;
}

export function deriveDisplayName(firstName: string, lastName: string): string {
  return `${firstName.trim()} ${lastName.trim()}`.trim();
}

/** Bevorzugt eine „echte" Domain gegenüber *.onmicrosoft.com. */
export function pickDefaultDomain(domains: string[]): string {
  return domains.find((d) => !d.endsWith('onmicrosoft.com')) ?? domains[0] ?? '';
}
